import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getWithExpiry } from './utils/storageUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotificationSoftAsk from './components/NotificationSoftAsk';
import { onMessageListener } from './notification/firebase';

const ProtectedRoute = ({ children }) => {
  const hostId = getWithExpiry('host_id');

  useEffect(() => {
    onMessageListener()
      .then(payload => {
        console.log("Foreground message received in App.js:", payload);
        if (payload.notification) {
          toast.info(
            <div
              onClick={() => {
                if (payload.data && payload.data.url) {
                  window.open(payload.data.url, '_blank');
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              <strong>{payload.notification.title}</strong>
              <p>{payload.notification.body}</p>
            </div>,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
      })
      .catch(err => console.error('Error receiving foreground message:', err));
  }, []);

  return hostId ? (
    <>
      <NotificationSoftAsk />
      <ToastContainer position="bottom-right" />
      {children}
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
